import { put, call,all } from 'redux-saga/effects';
import { setDropdownData, getDropDownDataFailed } from '../actions';
import { fetchCodes } from '../../api/shared';

export function* fetchDropDownSaga(action) {
  try {
    const [
      gender,
      race,
      maritalStatus,
      nationality,
      residential,
      country,
      validation,
      licenceValidity,
      clientInfo,
      drivingLicenseClassManual,
      residentialStatusManual,
      genderManual,
      drivingLicenseValidityManual,
      drivingLicenseClass,
      drivingLicenseStatus,
      otpSettings,
      agreeIncludeCpfText] = (yield all([
      call(fetchCodes, 'Gender', null, true),
      call(fetchCodes, 'Race', null, true),
      call(fetchCodes, 'Marital Status'),
      call(fetchCodes, 'Nationality',null, true),
      call(fetchCodes, 'Residential Status'),
      call(fetchCodes, 'Country',null, true),
      call(fetchCodes, 'Validation'),
      call(fetchCodes, 'LicenceValidity'),
      call(fetchCodes, 'CLIENT_INFORMATION'),
      call(fetchCodes, 'DrivingLicenseClassManual'),
      call(fetchCodes, 'ResidentialStatusManual'),
      call(fetchCodes, 'GenderManual'),
      call(fetchCodes, 'DrivingLicenseValidityManual'),
      call(fetchCodes, 'DrivingLicenseClass'),
      call(fetchCodes, 'DrivingLicenseStatus'),
      call(fetchCodes, 'OTPSettings'),
      call(fetchCodes, 'MyInfo'),])).map((x => x.data.data));

    yield put(setDropdownData('gender', gender.map(x => ({ label: x.value, value: x.key}))));
    yield put(setDropdownData('race', race.map(x => ({ label: x.value, value: x.key}))));
    yield put(setDropdownData('maritalStatus', maritalStatus.map(x => ({ label: x.value, value: x.key}))));
    yield put(setDropdownData('nationality', nationality.map(x => ({ label: x.value, value: x.key}))));
    yield put(setDropdownData('residentialStatus', residential.map(x => ({ label: x.value, value: x.key}))));
    yield put(setDropdownData('country', country.map(x => ({ label: x.value, value: x.key}))));
    yield put(setDropdownData('licenceValidity', licenceValidity.map(x => ({ label: x.value, value: x.key}))));
    yield put(setDropdownData('drivingLicenseManualClasses', drivingLicenseClassManual.map(x => ({ label: x.value, value: x.key}))));
    yield put(setDropdownData('residentialStatusManual', residentialStatusManual.map(x => ({ label: x.value, value: x.key}))));
    yield put(setDropdownData('genderManual', genderManual.map(x => ({ label: x.value, value: x.key}))));
    yield put(setDropdownData('drivingLicenseValidityManual', drivingLicenseValidityManual.map(x => ({ label: x.value, value: x.key}))));
    yield put(setDropdownData('drivingLicenseClass', drivingLicenseClass.map(x => ({ label: x.value, value: x.key}))));
    yield put(setDropdownData('drivingLicenseStatus', drivingLicenseStatus.map(x => ({ label: x.value, value: x.key}))));
    yield put(setDropdownData('otpSettings', otpSettings.map(x => ({ value: x.value, key: x.key}))));
    yield put(setDropdownData('myInfoSettings', agreeIncludeCpfText.map(x => ({ value: x.value, key: x.key}))));

    // Todo move this somewhere else since it's not dropdown
    yield put(setDropdownData('validation', validation));
    yield put(setDropdownData('defaultPhoneNo', 
    clientInfo.filter(x => x.category === "CLIENT_INFORMATION" && x.key === "PhoneNo")))
  } catch (error) {
    yield put(getDropDownDataFailed(error.response.data.msg));
  }
}